import React from "react";
import { Route, Routes, useMatch } from "react-router-dom";
import OutletTargets from "./views/outletTargets";
import SeasonCalendar from "../../elements/seasonCalendar";
import Dayparts from "../../elements/dayparts";
import "../style.scss";
import { useAppContext } from "../../../../AppContext";

function Settings() {
  const { user, chimeraserv, components } = useAppContext();
  const props = { user, chimeraserv, components };
  // Get the base path using useMatch
  const match = useMatch("/app/settings/*");
  const basePath = match ? `/${match.pathname.split("/")[1]}` : "/app/settings";

  const routes = [
    {
      name: "Outlet Targets",
      path: "outlet/targets",
      component: OutletTargets,
    },
  ];

  return (
    <div className="viewContainer">
      <Routes>
        <Route path="seasons" element={<SeasonCalendar />} />
        <Route path="dayparts" element={<Dayparts />} />
        <Route
          path={"outlet/targets"}
          element={
            <OutletTargets
              user={props.user}
              chimeraserv={props.chimeraserv}
              components={props.components}
            />
          }
        />
        <Route
          path="*"
          element={
            props.components.setting[0].component
              ? React.createElement(props.components.setting[0].component)
              : null
          }
        />
      </Routes>
    </div>
  );
}
export default Settings;
